/* ============================================================
   THRSDAY — shared chrome behaviour.
   Overlay open/close, newsletter, footer accordion.
   Cart operations are handled by cart.js (AJAX API).
   ============================================================ */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };

  /* ---- overlays ---- */
  var scrim = $('scrim');
  var menu = $('menu');
  var drawer = $('drawer');
  var search = $('search');

  function closeAll() {
    [menu, drawer, search].forEach(function (el) {
      if (el) { el.classList.remove('open'); el.setAttribute('aria-hidden', 'true'); }
    });
    if (scrim) scrim.classList.remove('open');
  }

  function openOverlay(el, useScrim) {
    closeAll();
    if (el) { el.classList.add('open'); el.setAttribute('aria-hidden', 'false'); }
    if (useScrim && scrim) scrim.classList.add('open');
  }

  function on(id, ev, fn) { var el = $(id); if (el) el.addEventListener(ev, fn); }

  on('openMenu', 'click', function () { openOverlay(menu, true); });
  on('closeMenu', 'click', closeAll);
  on('openCart', 'click', function () { openOverlay(drawer, true); });
  on('closeCart', 'click', closeAll);
  on('openSearch', 'click', function () {
    openOverlay(search, false);
    setTimeout(function () { var s = $('searchInput'); if (s) s.focus(); }, 120);
  });
  on('closeSearch', 'click', closeAll);
  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  if (menu) menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeAll); });

  /* ---- expose openCart for cart.js add-to-bag flow ---- */
  window.thrsdayOpenCart = function () { openOverlay(drawer, true); };

  /* ---- newsletter ---- */
  var newsForm = $('newsForm');
  if (newsForm) {
    newsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = $('newsThanks');
      if (t) t.textContent = (window.newsletterSuccess || 'Thank you for subscribing');
      newsForm.reset();
    });
  }

  /* ---- footer accordion (mobile) ---- */
  document.querySelectorAll('.col__head').forEach(function (head) {
    head.addEventListener('click', function () {
      if (window.matchMedia('(max-width:760px)').matches) {
        head.parentElement.classList.toggle('open');
      }
    });
  });

  /* ---- header: transparent → glass on first scroll ---- */
  (function () {
    var header = document.querySelector('.header');
    if (!header) return;
    function tick() { header.classList.toggle('scrolled', window.scrollY > 10); }
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  })();

  /* ---- prevent image right-click save and drag ---- */
  document.addEventListener('contextmenu', function (e) {
    if (e.target.tagName === 'IMG') e.preventDefault();
  });
  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG') e.preventDefault();
  });

  /* ---- reveal on scroll ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.tile, .editorial__main, .editorial__aside, .band__card').forEach(function (el) {
      io.observe(el);
    });
  }
})();
